(function () {
  'use strict';

  function initV9Logic() {
    var v9Container = document.querySelector('.right-column-v9');
    if (!v9Container) return;
    if (v9Container.getAttribute('data-ml353-bound') === '1') return;
    v9Container.setAttribute('data-ml353-bound', '1');

    if (/(?:^|[?&])v9=1(?:&|$)/.test(window.location.search)) {
      var v6Col = document.querySelector('.right-column-v6');
      if (v6Col) v6Col.style.setProperty('display', 'none', 'important');
      v9Container.style.setProperty('display', 'block', 'important');
    }

    var cards = v9Container.querySelectorAll('.v9-plan-card');
    var ctaBtn = document.getElementById('v9-add-to-cart');
    var v9Toggle = document.getElementById('v9-billingToggle');
    var v9ToggleLabel = document.getElementById('v9-toggle-label');
    var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

    if (!cards.length || !ctaBtn) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('is-active');
        });
        card.classList.add('is-active');

        var radio = card.querySelector('.v9-hidden-radio');
        if (radio) radio.checked = true;

        updateV9Pricing();
      });
    });

    function updateV9Pricing() {
      var isUpfront = v9Toggle ? v9Toggle.checked : true;
      v9Container.classList.toggle('is-monthly', !isUpfront);

      if (v9ToggleLabel) {
        v9ToggleLabel.textContent = isUpfront
          ? isDE
            ? 'Vorab bezahlen'
            : 'Billed upfront'
          : isDE
          ? 'Monatlich zahlen'
          : 'Pay monthly';
      }

      var desktopBanners = v9Container.querySelectorAll(
        '#ml-promo-v9-promo_banner_UhGbgr, .v9-promo-banner--left'
      );
      var mobileBanners = v9Container.querySelectorAll(
        '#ml-promo-v9-promo_banner_M9yVDk, .v9-promo-banner--right'
      );
      var extraDesktopBanner = document.getElementById('ml-promo-v9-promo_banner_UgkVfQ');
      var extraMobileBanner = document.getElementById('ml-promo-v9-promo_banner_e4w3Di');

      if (extraDesktopBanner) extraDesktopBanner.style.setProperty('display', 'none', 'important');
      if (extraMobileBanner) extraMobileBanner.style.setProperty('display', 'none', 'important');

      desktopBanners.forEach(function (b) {
        b.style.setProperty('display', 'none', 'important');
      });
      mobileBanners.forEach(function (b) {
        b.style.setProperty('display', 'none', 'important');
      });

      cards.forEach(function (card) {
        var titleEl = card.querySelector('.dynamic-v9-title');
        var priceEl = card.querySelector('.dynamic-v9-price');
        var readerTextEl = card.querySelector('.dynamic-v9-reader-text');
        var stripTextEl = card.querySelector('.dynamic-v9-strip-text');
        var stripPriceEl = card.querySelector('.dynamic-v9-strip-price');
        var readerPriceEl = card.querySelector('.dynamic-v9-reader-price');
        var cardBadge = card.querySelector('.v9-card-badge');

        if (cardBadge) {
          cardBadge.style.display = isUpfront ? 'block' : 'none';
        }

        if (titleEl) titleEl.innerHTML = isUpfront ? titleEl.dataset.upfront : titleEl.dataset.monthly;
        if (priceEl) priceEl.innerHTML = isUpfront ? priceEl.dataset.upfront : priceEl.dataset.monthly;
        if (readerTextEl) {
          readerTextEl.innerHTML = isUpfront ? readerTextEl.dataset.upfront : readerTextEl.dataset.monthly;
        }
        if (stripTextEl) {
          stripTextEl.innerHTML = isUpfront ? stripTextEl.dataset.upfront : stripTextEl.dataset.monthly;
        }
        if (stripPriceEl) {
          stripPriceEl.innerHTML = isUpfront ? stripPriceEl.dataset.upfront : stripPriceEl.dataset.monthly;
        }

        if (readerPriceEl) {
          var rPrice = isUpfront ? readerPriceEl.dataset.upfrontPrice : readerPriceEl.dataset.monthlyPrice;
          var rDiscount = isUpfront ? readerPriceEl.dataset.upfrontDiscount : readerPriceEl.dataset.monthlyDiscount;

          if (rDiscount && rDiscount.trim() !== '') {
            readerPriceEl.innerHTML =
              "<s style='opacity: 0.6; font-weight: normal; margin-right: 5px;'>" +
              rPrice +
              "</s> <span style='color:#F2853C; font-weight:700;'>" +
              rDiscount +
              '</span>';
          } else {
            readerPriceEl.innerHTML = rPrice;
          }
        }
      });

      var activeCard = v9Container.querySelector('.v9-plan-card.is-active') || cards[0];
      var radio = activeCard.querySelector('.v9-hidden-radio');
      if (radio) {
        var url = isUpfront ? radio.dataset.urlUpfront : radio.dataset.urlMonthly;
        ctaBtn.href = url ? url : '#';
      }
    }

    if (v9Toggle) {
      v9Toggle.addEventListener('change', updateV9Pricing);
    }

    window.addEventListener('resize', updateV9Pricing);
    window.addEventListener('pageshow', function () {
      updateV9Pricing();
    });

    updateV9Pricing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV9Logic);
  } else {
    initV9Logic();
  }
})();
